import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import { Plugins, CameraResultType } from '@capacitor/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ToastComponent} from '../toast/toast.component';
const { Camera } = Plugins;
import {Platform} from '@ionic/angular';

@Component({
  selector: 'app-take-photo',
  templateUrl: './take-photo.component.html',
  styleUrls: ['./take-photo.component.scss'],
})
export class TakePhotoComponent implements OnInit {

  @Input() enabled = true;
  @Output() photoTakenEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('camerainput') cameraInput;

  @Input() imageName;
  @Input() buttonLabel = 'Take Picture';

  constructor(
      private toastComponent: ToastComponent,
      private domSanitizer: DomSanitizer,
      private platform: Platform,
  ) { }

  ngOnInit() {}

  private base64ToArrayBuffer(base64) {
    const binary_string =  window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array( len );
    for (let i = 0; i < len; i++)        {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  async takePicture() {
    if (!this.platform.is('cordova')) {
      this.cameraInput.nativeElement.click();
      return;
    }
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Base64 // Uri
    });
    this.imageName = this.domSanitizer.bypassSecurityTrustResourceUrl(image.webPath);
    // this.form.get('photo').setValue('dummy');
    this.photoTakenEvent.emit({img: this.base64ToArrayBuffer(image.base64String), name: 'camera.jpg' });
  }

  changePhoto($event) {
    const _this = this;
    if ($event && $event.target.files[0] && $event.target.files[0].type.indexOf('image') < 0) {
      return this.toastComponent.presentToast('You did not select a valid image file');
    }
    const reader = new FileReader();
    reader.onload = function(event) {
      _this.photoTakenEvent.emit({ img: reader.result, name: $event.target.files[0].name});
    };
    reader.readAsArrayBuffer($event.target.files[0]);
  }


}
